'use strict';

var React = require('react');

var SvgStatusActiveMajor = function SvgStatusActiveMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.63 8.81a5.5 5.5 0 0 1 6.56-4.18.75.75 0 0 0 .325-1.464 7 7 0 1 0 5.32 8.35.75.75 0 0 0-1.465-.325 5.5 5.5 0 1 1-10.74-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.03 6.78a.75.75 0 0 0-1.06-1.06l-4.97 4.97-2.22-2.22a.75.75 0 0 0-1.06 1.06l2.75 2.75a.75.75 0 0 0 1.06 0l5.5-5.5Z"
  }));
};
SvgStatusActiveMajor.displayName = "StatusActiveMajor";

exports.SvgStatusActiveMajor = SvgStatusActiveMajor;
